export const getGlobalUi = (state) => state.globalUi
